import React from "react";

export const CLIENTS = [
  { name: "HERE Maps", sub: "Location Platform" },
  { name: "TomTom", sub: "Navigation & Maps" },
  { name: "Google", sub: "Geo & Cloud" },
  { name: "Esri", sub: "ArcGIS Platform" },
  { name: "Petal Maps", sub: "Huawei Mapping" },
  { name: "MapGro", sub: "Geodata Services" },
  { name: "Map & Allied", sub: "Mapping Solutions" },
  { name: "NextBillion.ai", sub: "AI Map Platform" },
  { name: "Niantic Labs", sub: "AR World-Scale Maps" },
];
